export default __webpack_public_path__ + "static/media/favicon.8ef0f254.png";